import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as faLang } from './modules/i18n/vocabs/fa';
import { ThemeModeService } from './_donstudio/partials/layout/theme-mode-switcher/theme-mode.service';

@Component({
  selector: 'app-root, body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // standalone: true,
  // imports: [
  //   RouterOutlet
  // ],
})
export class AppComponent implements OnInit {
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      faLang,
    );
  }

  ngOnInit() {
    this.modeService.init();
  }
}
